import React from "react";
import PrintField from "../../shared/PrintField";
import "./InvitationEGM3_EN.css";

// stable component type (capture / print mode comes from PrintModeContext)
const InputField = PrintField;

const InvitationEGM3_EN = React.forwardRef((props, ref) => {
  return (
    <div className="inv-page">
      <div className="inv-paper inv-en" ref={ref}>
        {/* Company (top-right) */}
        <div className="en-top-right">
          <InputField className="en-input long" /> Co., Ltd
        </div>

        {/* date (center) */}
        <div className="en-date-center">
          <InputField className="en-input long" />
          <span className="en-date-label">date</span>
        </div>

        {/* Subject */}
        <div className="en-row">
          <div className="en-col-label en-bold">Subject:</div>
          <div className="en-col-text en-bold">
            Invitation to attend the Extraordinary General Meeting of Shareholders No
            <InputField className="en-input small" />/<InputField className="en-input small" />
          </div>
        </div>

        {/* To */}
        <div className="en-row">
          <div className="en-col-label en-bold">To:</div>
          <div className="en-col-text en-bold">All Shareholders of the Company</div>
        </div>

        {/* NOTICE (ตามรูปตัวใหญ่ + จัดกลาง) */}
        <div className="en-notice">
          <span className="en-bold en-uc">NOTICE IS HEREBY GIVEN</span>{" "}
          that the Extraordinary General Meeting of the company No.
        </div>

        {/* line ต่อจาก notice */}
        <div className="en-notice-line">
          <InputField className="en-input small" />/<InputField className="en-input small" /> will be convened on{" "}
          <InputField className="en-input long" /> at <InputField className="en-input time" /> A.M. at No.{" "}
          <InputField className="en-input long" /> to consider the following agenda:
        </div>

        {/* Agenda list (ตามรูป: 1-4) */}
        <div className="en-agenda">
          <div className="en-ag-row">
            <div className="en-ag-left en-bold">Agenda 1</div>
            <div className="en-ag-right">
              To ratify the Minutes of Extraordinary Shareholders Meeting No{" "}
              <InputField className="en-input small" />/<InputField className="en-input small" /> held on{" "}
              <InputField className="en-input tiny" />
            </div>
          </div>

          <div className="en-ag-row">
            <div className="en-ag-left en-bold">Agenda 2</div>
            <div className="en-ag-right">To consideration and approve Liquidation report.</div>
          </div>

          <div className="en-ag-row">
            <div className="en-ag-left en-bold">Agenda 3</div>
            <div className="en-ag-right">To consideration to approve completeness of Liquidation.</div>
          </div>

          <div className="en-ag-row">
            <div className="en-ag-left en-bold">Agenda 4</div>
            <div className="en-ag-right">Others (if any)</div>
          </div>
        </div>

        {/* Bottom paragraph (ตามรูป) */}
        <p className="en-paragraph en-bottom">
          The company cordially invites all shareholders to attend the extraordinary general
          meeting No. <InputField className="en-input small" />/<InputField className="en-input small" /> at the date and time
          mention prior in this document.If by any means you are unable to attend this meeting and
          will send in a substitute, please fill in the proxy form so that the substitute can have
          the right to act in the meeting.
        </p>

        {/* Yours faithfully, + เส้นเซ็น */}
        <div className="en-yours">Yours faithfully,</div>

        <div className="en-sign-line" />

        <div className="en-sign-name">( <InputField className="en-input long" /> )</div>
      </div>
    </div>
  );
});

export default InvitationEGM3_EN;
